import React, { useRef } from 'react';
import ModalPortal from '../../../components/ModalPortal';

/**
 * CreateProjectModal - Modal component for creating new projects
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Callback to close the modal
 * @param {Function} props.onSubmit - Callback when form is submitted
 * @param {Object} props.newProject - Current new project data {name, description}
 * @param {Function} props.setNewProject - Callback to update new project data
 * @returns {JSX.Element} - Rendered create project modal component
 */
export default function CreateProjectModal({ isOpen, onClose, onSubmit, newProject, setNewProject }) {
    const overlayMouseDown = useRef(false);

    if (!isOpen) return null;

    const handleOverlayMouseDown = (e) => {
        if (e.target === e.currentTarget) overlayMouseDown.current = true;
    };

    const handleOverlayMouseUp = (e) => {
        if (e.target === e.currentTarget && overlayMouseDown.current) {
            onClose();
        }
        overlayMouseDown.current = false;
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <ModalPortal>
        <div
            className="modal-overlay"
            onMouseDown={handleOverlayMouseDown}
            onMouseUp={handleOverlayMouseUp}
        >
            <div className="modal-content" onClick={e => e.stopPropagation()} style={{ minWidth: '400px' }}>
                <h2 style={{ color: 'var(--text-primary)', margin: '0 0 1rem 0', fontSize: '1.25rem' }}>Create Project</h2>
                <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
                    Initialize an empty workspace. You can link families later.
                </p>
                
                <form onSubmit={handleFormSubmit} className="importer-form">
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600 }}>
                            Project Name
                        </label>
                        <input 
                            className="input-field" 
                            value={newProject.name}
                            onChange={e => setNewProject({...newProject, name: e.target.value})}
                            required
                            placeholder="e.g. Enterprise B2B Quoter"
                            autoFocus
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600 }}>
                            Description
                        </label>
                        <textarea 
                            className="textarea-field" 
                            value={newProject.description}
                            onChange={e => setNewProject({...newProject, description: e.target.value})}
                            placeholder="Optional description"
                            style={{ minHeight: '80px' }}
                        />
                    </div>
                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn-primary" style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)' }}>
                            Create
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </ModalPortal>
    );
}